import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import ToastModal from "../ToastModal";
import { saveUserAadharDetails } from "store/reducers/login/LoginSlice";

const AadharOAuth2RedirectHandler = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { authToken } = useSelector((state) => state.login.authData);
  const transationId = useSelector(
      (state) => state.login.userAddharTransationDetails?.transationId
    );

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    getAadharDetails();
  }, []);

  const getAadharDetails = async () => {
    const result = await apiHandler({
      url: endpoint.AADHAR_KYC_DETAILS_API,
      authToken: authToken,
      method:"POST",
      data:{
        transactionId: transationId
      }
    });
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
      navigate("/journey/AadharDetails", {
        state: {
          data: result?.data
        },
      });
    } else {
      dispatch(saveUserAadharDetails(result.data));
      navigate("/journey/AadharDetails");
    }
  };
  return (
    <>
        {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </>
  );
};

export default AadharOAuth2RedirectHandler;
